<div class="container-fluid mt-3 mb-3 theme">
  <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
    <div class="col-lg-10">
      <div class="d-flex">
        <h1>Cyber Audit Follow On </h1>
        <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
          <li><a routerLink="">Home</a></li>
          <li><a routerLink="/complianceAdmin/cyberAudit/adminMIS"> Cyber Audit Follow On Action </a></li>
          <li class="active"> <a skipLocationChange aria-current="page">Cyber Audit Follow On Action</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="card card-body">
    <div>
      <button type="button" class="btn btn-primary mt-1 mb-1 ml-2" (click)="downloadPdf()"><i
      class="fa fa-download" aria-hidden="true"></i> Download Audit Report</button>
      <!-- <button type="button" class="btn btn-primary mt-1 mb-1 ml-2" *ngIf="enableSignPdfDnld" (click)="downloadSignedReport()"><i class="fa fa-download"
    aria-hidden="true"></i> Download Auditor Signed Report</button> -->
    <!-- <button type="button" class="btn btn-primary mt-1 mb-1 ml-2" *ngIf="enableAuditorFoSignPdfDnld"
    (click)="downloadCertificate('AUDITOR')"><i class="fa fa-download" aria-hidden="true"></i>Auditor Signed
  Certificate</button>

  <button type="button" class="btn btn-primary mt-1 mb-1 ml-2" *ngIf="enableMemberFoSignPdfDnld"
    (click)="downloadCertificate('ENIT')"><i class="fa fa-download" aria-hidden="true"></i>Member Signed
  Certificate</button> -->

  @if (enableAuditorFoSignPdfDnld) {
    <button type="button" class="btn btn-primary mt-1 mb-1 ml-2"
      (click)="downloadSignedReport('AUDITOR')"><i class="fa fa-download" aria-hidden="true"></i>Auditor
    Signed TOR </button>
  }

  @if (enableMemberFoSignPdfDnld) {
    <button type="button" class="btn btn-primary mt-1 mb-1 ml-2"
      (click)="downloadSignedReport('ENIT')"><i class="fa fa-download" aria-hidden="true"></i>Member Signed
    TOR </button>
  }
</div>
<ag-grid-angular #cyberAuditAgGrid class="width-height"
  [theme]="theme"
  [columnDefs]="cyberAuditFOcolumnDefs" [rowData]="cyberAuditFORowData"
  [defaultColDef]="cyberAuditDefcolumnDefs" (gridReady)="onGridReady($event)"
[singleClickEdit]="true"></ag-grid-angular>
</div>

@if (cyberAuditData.currentStage=='4' || cyberAuditData.currentStage=='5') {
  <div class="card card-body col-lg-12 mt-3 colorborder"
    >
    <form [formGroup]="approveRejectForm">
      <div class="card card-header">
        <h6>Audit Request Decision Form </h6>
      </div>
      <div class="card card-body">
        <div class="row">
          @if (cyberAuditData.commentByMaker!='' && cyberAuditData.commentByMaker!=null && cyberAuditData.commentByMaker!=undefined) {
            <div class="form-group col-lg-3"
              >
              <label>Comment By Maker </label>
              <input type="text" class="form-control color-green" formControlName="commentByMaker">
            </div>
          }
          @if (cyberAuditData.commentByMaker!='' && cyberAuditData.commentByMaker!=null && cyberAuditData.commentByMaker!=undefined) {
            <div class="form-group col-lg-3"
              >
              <label>Approved Date </label>
              <input type="text" class="form-control" formControlName="requestApprovedDateByMaker">
            </div>
          }
          @if (cyberAuditData.commentByChecker!=='' && cyberAuditData.commentByChecker!==null && cyberAuditData.commentByChecker!==undefined) {
            <div class="form-group col-lg-3"
              >
              <label>Comment By Checker </label>
              <input type="text" class="form-control color-green" formControlName="commentByChecker">
            </div>
          }
          @if (cyberAuditData.commentByChecker!=='' && cyberAuditData.commentByChecker!==null && cyberAuditData.commentByChecker!==undefined) {
            <div class="form-group col-lg-3"
              >
              <label>Approved Date </label>
              <input type="text" class="form-control" formControlName="requestApprovedDateByChecker">
            </div>
          }
        </div>
        @if (cyberAuditData.currentStage=='4' || cyberAuditData.currentStage=='5') {
          <div class="row">
            <div class="col-lg-6 form-group">
              <label>Comments : </label>
              <textarea class="form-control" rows="3" formControlName="auditComment"
              id="auditComment"></textarea><br />
            </div>
          </div>
        }
        <div class="row">
          <div class="col-lg-2">
            @if (cyberAuditData.currentStage=='4') {
              <button type="button" class="btn btn-success"
              (click)='submitApproverRequest("Maker","Y")'>Maker Approve</button>
            }
            @if (cyberAuditData.currentStage=='5' && isCheckerAllowed) {
              <button type="button"
                class="btn btn-success" (click)='submitApproverRequest("Checker","Y")'>Checker
              Approve</button>
            }
          </div>
          <div class="col-lg-2">
            @if (cyberAuditData.currentStage=='4') {
              <button type="button" class="btn btn-danger"
              (click)='submitApproverRequest("Maker","N")'>Maker Reject</button>
            }
            @if (cyberAuditData.currentStage=='5'  && isCheckerAllowed ) {
              <button type="button"
                class="btn btn-danger" (click)='submitApproverRequest("Checker","N")'>Checker
              Reject</button>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
}

</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p class="spinner-tag">Please wait.</p>
</ngx-spinner>